import {
  ERROR_HANDLING_IF_INACTIVE_OPTIONS,
  ERROR_HANDLING_ON_CHILD_CANCELLED_OPTIONS,
  ERROR_HANDLING_ON_ERROR_OPTIONS,
  ERROR_HANDLING_ON_ZERO_RECORDS_OPTIONS,
  INCLUDED_RECORDS_OPTIONS,
} from 'pages/SmartConnectors/constants';
import type {
  GenericOption,
  RunSmartConnectorErrorHandling,
  RunSmartConnectorInputData,
} from 'pages/SmartConnectors/types';
import { type TFunction } from 'react-i18next';

export const getTranslatedOptions = (t: TFunction) => {
  const onZeroRecordsOptions: GenericOption<
    RunSmartConnectorErrorHandling['on_zero_records']
  >[] = [
    {
      value: ERROR_HANDLING_ON_ZERO_RECORDS_OPTIONS.skip,
      label: t('Skip'),
    },
    {
      value: ERROR_HANDLING_ON_ZERO_RECORDS_OPTIONS.error,
      label: t('Error'),
    },
  ];

  const ifInactiveOptions: GenericOption<
    RunSmartConnectorErrorHandling['if_inactive']
  >[] = [
    {
      value: ERROR_HANDLING_IF_INACTIVE_OPTIONS.queue,
      label: t('Queue an Execution'),
    },
    {
      value: ERROR_HANDLING_IF_INACTIVE_OPTIONS.skip,
      label: t('Skip this step'),
    },
    {
      value: ERROR_HANDLING_IF_INACTIVE_OPTIONS.error,
      label: t('Error'),
    },
  ];

  const onErrorOptions: GenericOption<
    RunSmartConnectorErrorHandling['on_error']
  >[] = [
    {
      value: ERROR_HANDLING_ON_ERROR_OPTIONS.ignore,
      label: t('Ignore'),
    },
    {
      value: ERROR_HANDLING_ON_ERROR_OPTIONS.error,
      label: t('Error'),
    },
  ];

  const onChildCancelledOptions: GenericOption<
    RunSmartConnectorErrorHandling['on_child_cancelled']
  >[] = [
    {
      value: ERROR_HANDLING_ON_CHILD_CANCELLED_OPTIONS.continue,
      label: t('Continue'),
    },
    {
      value: ERROR_HANDLING_ON_CHILD_CANCELLED_OPTIONS.cancel,
      label: t('Cancel this Execution'),
    },
  ];

  return {
    onZeroRecordsOptions,
    ifInactiveOptions,
    onErrorOptions,
    onChildCancelledOptions,
  };
};

export const getIncludedRecordsOptions = (t: TFunction) => {
  const includedRecordsOptions: GenericOption<
    RunSmartConnectorInputData['filter'] | ''
  >[] = [
    {
      value: '',
      label: t('All Matched Records'),
    },
    {
      value: INCLUDED_RECORDS_OPTIONS.created,
      label: t('Created Records'),
    },
    {
      value: INCLUDED_RECORDS_OPTIONS.updated,
      label: t('Updated Records'),
    },
  ];

  return includedRecordsOptions;
};
